import { useState, useEffect } from 'react';
// import { mockMessagesData } from '../data/mockData';
import type { MessagesData, MessagesResponse } from '../types';
import { formatMessages, getLegacyBaseUrl } from '../utils';

const useMessagesApi = (
  clientId: string,
  clientName: string,
  bookkeeperId: string,
): { messages?: MessagesData; loading: boolean; error?: Error } => {
  const [messages, setMessages] = useState<MessagesData>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();

  useEffect((): void => {
    if (!clientId || !bookkeeperId || !clientName) return;
    fetch(
      `${getLegacyBaseUrl()}/gateway/web/api/messages/${clientId}?before=${Date.now()}&clientId=${clientId}&full=true&group=BENCH&limit=15&names=feed.message.created&names=feed.message.edited&preview=false&stats=false&viewerId=${bookkeeperId}`,
      {
        method: 'GET',
        credentials: 'include',
      },
    )
      .then(response => {
        if (!response?.ok) throw new Error();
        return response.json();
      })
      .then((response: MessagesResponse[]) => formatMessages(response[0], clientName))
      .then((data: MessagesData) => setMessages(data))
      .catch((error: Error) => {
        /* eslint-disable no-console */
        console.log('Failed to fetch messages data:', error.message);
        // setMessages(mockMessagesData);
        setError(error);
      })
      .finally(() => setLoading(false));
  }, [clientId, bookkeeperId, clientName]);

  return { messages, loading, error };
};

export default useMessagesApi;
